export const LoadsDataMixin = {
  data() {
    return {
      loading: false,
      reloadInterval: 60000, // 1 minute
    };
  },
  created() {
    this.load();

    setInterval(this.load, this.reloadInterval);
  },
  methods: {
    async load() {
      if (this.loading) {
        this.cancelRequests();
      }

      if (!this.hasData) {
        this.loading = true;
      }

      await this.loadData();
      this.loading = false;
    },
  },
};
